/**
 * Full-screen HTML overlays: title, win, lose.
 * These sit on top of everything; `pointer-events:all` so they capture clicks.
 */

function getLeaderboard(): Array<{ name: string; hoops: number }> {
  const raw = localStorage.getItem('bamford2-lb')
  if (!raw) return [
    { name: 'REGBAM', hoops: 5 },
    { name: 'CLAUDE', hoops: 4 },
    { name: 'WADEH!', hoops: 3 },
  ]
  return JSON.parse(raw)
}

function saveScore(name: string, hoops: number): void {
  const lb = getLeaderboard()
  lb.push({ name: name.toUpperCase().substring(0, 6), hoops })
  lb.sort((a, b) => b.hoops - a.hoops)
  localStorage.setItem('bamford2-lb', JSON.stringify(lb.slice(0, 5)))
}

function renderLeaderboard(): string {
  const medals = ['🥇', '🥈', '🥉', '  ', '  ']
  return getLeaderboard().slice(0, 5).map((e, i) =>
    `<div style="color:#aaa;font-size:11px;font-family:monospace">${medals[i]} ${e.name.padEnd(6)} — ${e.hoops}/5 hoops</div>`
  ).join('')
}

export class Screens {
  private _container: HTMLElement

  constructor() {
    this._container = document.createElement('div')
    this._container.style.cssText = `
      position:fixed; top:0; left:0; width:100%; height:100%; z-index:20;
      display:none; pointer-events:all;
    `
    document.body.appendChild(this._container)
  }

  showTitle(onStart: () => void): void {
    this._show(`
      <div style="background:rgba(5,15,5,0.97);width:100%;height:100%;display:flex;align-items:center;justify-content:center">
        <div style="text-align:center;max-width:480px;padding:24px">
          <div style="color:#c8a415;font-size:36px;font-family:Georgia,serif;font-weight:700;margin-bottom:8px">BAMFORD'S COMEBACK</div>
          <div style="color:#fff;font-size:18px;font-family:Georgia,serif">GC World Championship Final</div>
          <div style="color:#aaa;font-size:16px;font-family:Georgia,serif;margin-bottom:20px">Cairo, Egypt — 2013</div>
          <div style="color:#ff6666;font-size:24px;font-weight:700;font-family:monospace;margin-bottom:12px">NASR 6 – 2 BAMFORD</div>
          <div style="color:#ffcc00;font-size:14px;margin-bottom:24px">Five hoops to be World Champion.</div>
          <button id="start-btn" style="
            background:#c8a415; color:#000; border:none; padding:12px 32px;
            font-size:16px; font-weight:700; cursor:pointer; border-radius:4px;
            letter-spacing:1px;
          ">CLICK TO START</button>
          <div style="margin-top:24px">
            <div style="color:#555;font-size:11px;font-family:monospace;margin-bottom:8px">── HALL OF CHAMPIONS ──</div>
            ${renderLeaderboard()}
          </div>
        </div>
      </div>
    `)
    document.getElementById('start-btn')?.addEventListener('click', () => {
      this.hide()
      onStart()
    })
  }

  showWin(onPlayAgain: () => void): void {
    this._show(`
      <div style="background:rgba(5,5,20,0.97);width:100%;height:100%;display:flex;align-items:center;justify-content:center">
        <div style="text-align:center;max-width:480px;padding:24px">
          <div style="font-size:40px;margin-bottom:8px">🏆</div>
          <div style="color:#ffd700;font-size:34px;font-family:Georgia,serif;font-weight:700">WORLD CHAMPION</div>
          <div style="color:#fff;font-size:24px;font-family:Georgia,serif;margin:8px 0">BAMFORD 7 – 6 NASR</div>
          <div style="color:#c8a415;font-size:14px;font-family:Georgia,serif;margin-bottom:20px;line-height:1.6">
            The greatest comeback in Golf Croquet history.<br>
            From 6–2 down under the Cairo floodlights.<br>
            A standing ovation. A legend is made.
          </div>
          <div style="margin-bottom:16px">
            <input id="name-input" maxlength="6" placeholder="Enter name (6 chars)" style="
              padding:8px 12px; font-size:16px; font-family:monospace; font-weight:700;
              text-align:center; background:#111; color:#ffcc00; border:1px solid #555;
              border-radius:4px; width:200px; text-transform:uppercase;
            ">
          </div>
          <button id="save-btn" style="
            background:#c8a415; color:#000; border:none; padding:10px 24px;
            font-size:14px; font-weight:700; cursor:pointer; border-radius:4px; margin-right:8px;
          ">SAVE SCORE</button>
          <button id="again-btn" style="
            background:#333; color:#fff; border:1px solid #555; padding:10px 24px;
            font-size:14px; cursor:pointer; border-radius:4px;
          ">PLAY AGAIN</button>
          <div id="lb-section" style="margin-top:20px">
            <div style="color:#555;font-size:11px;font-family:monospace;margin-bottom:8px">── HALL OF CHAMPIONS ──</div>
            ${renderLeaderboard()}
          </div>
        </div>
      </div>
    `)

    const nameInput = document.getElementById('name-input') as HTMLInputElement
    document.getElementById('save-btn')?.addEventListener('click', () => {
      const name = nameInput.value.trim()
      if (name.length > 0) {
        saveScore(name, 5)
        const lb = document.getElementById('lb-section')
        if (lb) lb.innerHTML = `
          <div style="color:#555;font-size:11px;font-family:monospace;margin-bottom:8px">── HALL OF CHAMPIONS ──</div>
          ${renderLeaderboard()}
        `
      }
    })
    document.getElementById('again-btn')?.addEventListener('click', () => {
      this.hide()
      onPlayAgain()
    })
  }

  showLose(hooopsScored: number, onPlayAgain: () => void): void {
    this._show(`
      <div style="background:rgba(20,5,5,0.97);width:100%;height:100%;display:flex;align-items:center;justify-content:center">
        <div style="text-align:center;max-width:480px;padding:24px">
          <div style="color:#ff4444;font-size:30px;font-family:Georgia,serif;font-weight:700">NASR TAKES THE TITLE</div>
          <div style="color:#aaa;font-size:16px;font-family:Georgia,serif;margin:12px 0;line-height:1.6">
            So close. The comeback falls short.<br>
            Ahmed Nasr wins on home soil.
          </div>
          <div style="color:#666;font-size:13px;margin-bottom:20px">${hooopsScored} of 5 hoops scored</div>
          <div style="margin-bottom:16px">
            <input id="name-input" maxlength="6" placeholder="Enter name (6 chars)" style="
              padding:8px 12px; font-size:16px; font-family:monospace; font-weight:700;
              text-align:center; background:#111; color:#ffcc00; border:1px solid #555;
              border-radius:4px; width:200px; text-transform:uppercase;
            ">
          </div>
          <button id="save-btn" style="
            background:#555; color:#fff; border:none; padding:10px 24px;
            font-size:14px; font-weight:700; cursor:pointer; border-radius:4px; margin-right:8px;
          ">SAVE SCORE</button>
          <button id="again-btn" style="
            background:#c8a415; color:#000; border:none; padding:10px 24px;
            font-size:14px; font-weight:700; cursor:pointer; border-radius:4px;
          ">TRY AGAIN</button>
          <div id="lb-section" style="margin-top:20px">
            <div style="color:#555;font-size:11px;font-family:monospace;margin-bottom:8px">── HALL OF CHAMPIONS ──</div>
            ${renderLeaderboard()}
          </div>
        </div>
      </div>
    `)

    const nameInput = document.getElementById('name-input') as HTMLInputElement
    document.getElementById('save-btn')?.addEventListener('click', () => {
      const name = nameInput.value.trim()
      if (name.length > 0) {
        saveScore(name, hooopsScored)
        const lb = document.getElementById('lb-section')
        if (lb) lb.innerHTML = `
          <div style="color:#555;font-size:11px;font-family:monospace;margin-bottom:8px">── HALL OF CHAMPIONS ──</div>
          ${renderLeaderboard()}
        `
      }
    })
    document.getElementById('again-btn')?.addEventListener('click', () => {
      this.hide()
      onPlayAgain()
    })
  }

  hide(): void {
    this._container.style.display = 'none'
    this._container.innerHTML = ''
  }

  private _show(html: string): void {
    this._container.innerHTML = html
    this._container.style.display = 'block'
  }
}
